/* Native Shopify commerce. No cached product prices, proxy checkout or localStorage cart. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const live = document.querySelector('[data-feedback]');
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-gallery-src]');
    if (thumbnail) {
      const gallery = thumbnail.closest('section');
      const image = gallery?.querySelector('[data-primary-image] img');
      if (image) {
        image.removeAttribute('srcset'); image.src = thumbnail.dataset.gallerySrc;
        gallery.querySelectorAll('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
      }
    }
    const primary = event.target.closest('[data-primary-image]');
    if (primary?.querySelector('img')) {
      let dialog = document.querySelector('#kc-zoom');
      if (!dialog) {
        dialog = document.createElement('dialog'); dialog.id = 'kc-zoom'; dialog.className = 'kc-zoom';
        const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Schließen ×'; button.addEventListener('click', () => dialog.close());
        const image = document.createElement('img'); dialog.append(button,image); document.body.append(dialog);
        dialog.addEventListener('click', e => { if(e.target === dialog) dialog.close(); });
      }
      const source = primary.querySelector('img'), target = dialog.querySelector('img');
      target.src = source.currentSrc || source.src; target.alt = source.alt; dialog.showModal();
    }
  });
  document.querySelectorAll('[data-primary-image]').forEach(element => {
    if (!element.querySelector('img')) return;
    element.tabIndex = 0; element.setAttribute('role','button'); element.setAttribute('aria-label','Produktbild vergrößern');
    element.addEventListener('keydown', event => { if(event.key === 'Enter' || event.key === ' ') { event.preventDefault(); element.click(); } });
  });
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape') document.querySelectorAll('details.mobile-menu[open],details[class*="_mobileMenu_"][open]').forEach(menu=>menu.removeAttribute('open'));
  });
  document.querySelectorAll('[data-variant-picker]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-native-product]').forEach(form => {
    form.addEventListener('submit', async event => {
      if (!window.fetch || !form.reportValidity()) return;
      event.preventDefault();
      const button = form.querySelector('[name="add"]');
      if(button.disabled) return;
      const error = form.querySelector('[data-product-error]'), success = form.querySelector('[data-cart-success]');
      button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = 'Wird hinzugefügt …'; error.hidden = true; success.hidden = true;
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result = await response.json();
        if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Dieser Artikel kann momentan nicht hinzugefügt werden. Bitte prüfe die Menge und Verfügbarkeit.');
        success.hidden = false; if(live) live.textContent = 'Zum Warenkorb hinzugefügt.';
        // A failed badge refresh must never turn a successful add into a repeatable failure.
        try {
          const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
          if(cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(badge=>{badge.textContent=String(cart.item_count);badge.hidden=!cart.item_count;});
            document.querySelectorAll('[data-cart-link]').forEach(link=>link.setAttribute('aria-label',`Warenkorb, ${cart.item_count} Artikel`));
          }
        } catch { /* Server cart remains authoritative. */ }
      } catch (reason) { error.textContent = reason.message || 'Die Verbindung wurde unterbrochen. Bitte prüfe deinen Warenkorb, bevor du es erneut versuchst.'; error.hidden = false; }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = 'In den Warenkorb'; }
    });
  });
  document.querySelectorAll('[data-share-product]').forEach(button=>button.addEventListener('click',async()=>{
    try { if(navigator.share) await navigator.share({title:document.title,url:location.href}); else { await navigator.clipboard.writeText(location.href); if(live) live.textContent='Produktlink kopiert.'; } } catch { /* Dismissal leaves the product page intact. */ }
  }));
})();
